'use client';
import { Loading } from '@/shared/components/parts/Loading';
import { NoticePage } from '@/shared/components/parts/NoticePage';
import { ConfirmForm } from './ConfirmForm';
import { useAccountDeletion } from './index.hook';

export const AccountDeletion: React.FC = () => {
  const { state, invokeDeletion, isLoading } = useAccountDeletion();

  return (
    <>
      {(state.pageStatus === 'INIT' || state.pageStatus === 'POST_PROCESS') && (
        <Loading />
      )}
      {state.pageStatus === 'CONFIRM' && (
        <ConfirmForm
          state={state}
          invokeDeletion={invokeDeletion}
          isLoading={isLoading}
        />
      )}
      {state.pageStatus === 'COMPLETE' && (
        <NoticePage
          title="H2Uアカウントの削除が完了しました"
          texts={[
            'H2Uをご利用いただきありがとうございました。',
            'またのご利用を心よりお待ちしております。',
          ]}
          links={[
            {
              href: '/',
              text: 'ホーム',
            },
          ]}
        />
      )}
    </>
  );
};
